import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as saveAs from 'file-saver';
import { SnoozeIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/snooze-incident-dialog/snooze-incident-dialog.component';
import { VerifyIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/verify-incident-dialog/verify-incident-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-incident-security-callback',
  templateUrl: './incident-security-callback.component.html',
  styleUrls: ['./incident-security-callback.component.scss'],
})
export class IncidentSecurityCallbackComponent {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) dataSource: MatTableDataSource<IIncidents>;
  @Output() initCreateManualEvent = new EventEmitter<boolean>();
  @Output() verifyIncident = new EventEmitter<any>();
  @Output() snoozeIncident = new EventEmitter<any>();
  @Output() showIncidentDetail = new EventEmitter<any>();
  @Output() refreshIncidentData = new EventEmitter<any>();
  @Input() set incidentTableData(val: IIncidents[]) {
    // this.temp = organizeVisitorTableData(val);
    this.temp = this.getSecurityCallbackIncidents(val);
    this.filtered = this.temp;
    this.filteredDataSource = new MatTableDataSource(this.temp);
  }
  @Input() set isIncidentDetailsClosed(val: boolean) {
    if (!val) {
      this.isShowDetails = false;
      this.expandedDetail = '';
    }
  }

  @Input() set isShowHeader(val: boolean) {
    this.showHeader = val;
  }
  showHeader = true;
  filteredDataSource: MatTableDataSource<IIncidents>;
  rowIndex = 0;
  isShowDetails = false;
  expandedDetail = '';
  role = localStorage.getItem('Role');
  displayedColumns = ['name', 'date', 'time', 'asset', 'action', 'Details'];
  temp: IIncidents[] = [];
  filtered: IIncidents[] = [];
  screenSize: ScreenType;
  constructor(
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ngOnInit(): void {
    this.filteredDataSource.paginator = this.paginator;
    this.filteredDataSource.sort = this.sort;
  }
  getSecurityCallbackIncidents(securityCallbackIncidents: IIncidents[]) {
    // Filter incidents with incidentStatus = 0
    const incidentsWithStatus0 = securityCallbackIncidents.filter(
      (incident) => incident.incidentStatus === 0
    );

    // Filter incidents with other incidentStatus
    const incidentsWithOtherStatus = securityCallbackIncidents.filter(
      (incident) => incident.incidentStatus !== 0
    );

    // Sort the incidents, with status 0 first
    const sortedIncidents = incidentsWithStatus0.concat(
      incidentsWithOtherStatus
    );
    // Assign the sorted array back to the property
    return sortedIncidents;
  }
  applyFilterCustom(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredDataSource.filter = filterValue.trim().toLowerCase();
    if (this.filteredDataSource.paginator) {
      this.filteredDataSource.paginator.firstPage();
    }
    // Filter the temp array
    this.filtered = this.temp.filter((incident: IIncidents) => {
      const incidentNameMatch = incident.incidentName
        .trim()
        .toLowerCase()
        .includes(filterValue);
      const incidentIdMatch = incident.incidentId
        .toString()
        .includes(filterValue); // Assuming visitorId is a number
      const incidentStatusMatch = incident.incidentStatus
        .toString()
        .includes(filterValue); // Assuming securityStatus is a number
      const assigneeMatch = incident.assignedTo
        .toString()
        .includes(filterValue);

      const reporterMatch = incident.eventCreatedBy
        .toString()
        .includes(filterValue);

      return (
        incidentIdMatch ||
        incidentStatusMatch ||
        incidentNameMatch ||
        reporterMatch ||
        assigneeMatch
      );
    });
  }
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredDataSource.filter = filterValue.trim().toLowerCase();
    if (this.filteredDataSource.paginator) {
      this.filteredDataSource.paginator.firstPage();
    }
  }
  onShowDetails(val: any) {
    this.isShowDetails = true;
    this.expandedDetail = val.incidentId;
    this.showIncidentDetail.emit(val);
  }
  onCreateManualEvent() {
    this.initCreateManualEvent.emit();
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.displayedColumns,
      event.previousIndex,
      event.currentIndex
    );
  }
  downloadCSV() {
    const data: any = this.temp;
    const replacer = (key: any, value: any) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], { type: 'text/csv' });
    saveAs(blob, 'myFile.csv');
  }
  // onVerifyIncident(val: any) {
  //   const updatedVal = { ...val, screenSize: this.screenSize };
  //   const dialogRef = this.dialog.open(VerifyIncidentDialogComponent, {
  //     disableClose: true,
  //     data: updatedVal,
  //   });
  //   dialogRef.afterClosed().subscribe((result: string) => {
  //     let data = {
  //       status:
  //         result == 'Open'
  //           ? '0'
  //           : result == 'Close'
  //           ? '1'
  //           : result == 'Verified'
  //           ? '2'
  //           : result == 'Snooze'
  //           ? '3'
  //           : result == 'In-Progress'
  //           ? '4'
  //           : result == 'On-Hold'
  //           ? '5'
  //           : result == 'Approved'
  //           ? '6'
  //           : result == 'Rejected'
  //           ? '7'
  //           : '',
  //       incidentId: val.incidentId,
  //     };
  //     if (result) {
  //       this.verifyIncident.emit(data);
  //     }
  //   });
  // }
  onSnoozeIncident(val: IIncidents) {
    const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      let data = {
        isSnooze: true,
        durationType: result.durationType,
        durationSize: result.durationSize,
        incidentId: val.incidentId,
        orgId: val.orgId,
        incidenType: val.incidentType,
        incidentName: val.incidentName,
        incidentStatusTimeline: val.incidentStatusTimeline,
        assignedBy: localStorage.getItem('FullName'),
        assignedById: localStorage.getItem('UserId'),
        createBy: val.eventCreatedBy,
        createById: val.eventCreatedByUserID,
        assignedTo: val.assignedTo,
        assignedToUserId: val.assignedToUserId,
        evidence: val.eventEvidence,
      };
      if (result) {
        this.snoozeIncident.emit(data);
      }
    });
  }
  onClickStatus(val: any) {
    const dialogRef = this.dialog.open(VerifyIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      let data = {
        status:
          result == 'Open'
            ? '0'
            : result == 'Close'
            ? '1'
            : result == 'Verified'
            ? '2'
            : result == 'Snooze'
            ? '3'
            : result == 'In-Progress'
            ? '4'
            : result == 'On-Hold'
            ? '5'
            : result == 'Approved'
            ? '6'
            : result == 'Rejected'
            ? '7'
            : result == 'Completed'
            ? '8'
            : '',
        incidentId: val.incidentId,
      };
      if (data.status == '3') {
        const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
          disableClose: true,
          data: val,
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          let data = {
            isSnooze: true,
            durationType: result.durationType,
            durationSize: result.durationSize,
            incidentId: val.incidentId,
            status: '3',
          };
          if (result) {
            this.verifyIncident.emit(data);
          }
        });
      } else {
        if (result) {
          this.verifyIncident.emit(data);
        }
      }
    });
  }
  onRefreshIncidet() {
    this.refreshIncidentData.emit();
  }

  ScreenType = ScreenType;
}
